<template>
    <form class="login-form" @submit.prevent="handleSubmit">
        <label for="login-email">Email</label>
        <input id="login-email" v-model="email" type="email" required autocomplete="email">
        <label for="login-password">Password</label>
        <input id="login-password" v-model="password" type="password" required autocomplete="current-password">
        <p v-if="error" class="form-error" role="alert">{{ error }}</p>
        <button class="primary-button" type="submit" :disabled="loading">
            <span v-show="loading" class="loading-spinner" aria-hidden="true"></span>
            {{ loading ? 'Signing in...' : 'Sign in' }}
        </button>
    </form>
</template>

<script>
import { ref } from 'vue'
import useLogin from '../composables/useLogin'
export default {
    setup(props, context) {
        // refs
        const email = ref("")
        const password = ref("")
        const loading = ref(false)

        const { error, login } = useLogin()

        const handleSubmit = async () => {
            loading.value = true
            await login(email.value, password.value)
            loading.value = false
            if (!error.value) {
                context.emit('login')
            }
        }

        return { 
            email, 
            password, 
            handleSubmit, 
            error, 
            loading
        }
    }
}
</script>
